// Standard superyacht crew ranks / epaulets, grouped by department.
// Used across UsersPanel and future crew profile pickers.
export const YACHT_RANKS = [
  {
    department: "Deck",
    ranks: [
      "Captain",
      "Staff Captain",
      "Chief Officer",
      "First Officer",
      "Second Officer",
      "Third Officer",
      "Bosun",
      "Bosun's Mate",
      "Lead Deckhand",
      "Deckhand",
      "AB Deckhand",
      "OS Deckhand",
      "Deckhand / Divemaster",
    ],
  },
  {
    department: "Engineering",
    ranks: [
      "Chief Engineer",
      "Second Engineer",
      "Third Engineer",
      "Fourth Engineer",
      "ETO (Electro-Technical Officer)",
      "AV/IT Officer",
      "Motorman / Oiler",
    ],
  },
  {
    department: "Interior",
    ranks: [
      "Purser",
      "Chief Stewardess",
      "Chief Steward",
      "Second Stewardess",
      "Second Steward",
      "Third Stewardess",
      "Junior Stewardess",
      "Junior Steward",
      "Interior Manager",
      "Housekeeper",
      "Laundry Steward",
      "Service Steward",
    ],
  },
  {
    department: "Galley",
    ranks: [
      "Head Chef",
      "Executive Chef",
      "Sous Chef",
      "Chef de Partie",
      "Crew Chef",
      "Solo Chef",
      "Pastry Chef",
    ],
  },
  {
    department: "Spa & Wellness",
    ranks: [
      "Spa Manager",
      "Spa Therapist",
      "Masseuse / Masseur",
      "Beautician",
      "Yoga / Fitness Instructor",
      "Nurse / Medic",
    ],
  },
  {
    department: "Other",
    ranks: [
      "Yacht Manager",
      "Security Officer",
      "Personal Trainer",
      "Watersports Instructor",
      "Nanny",
    ],
  },
];

export const ALL_RANKS = YACHT_RANKS.flatMap((g) => g.ranks);
